import { Paragraph } from 'designsystem/components/1-atoms/Paragraph';

export const FooterCardFeature: React.FC<Content.FooterCard> = ({ content }) => {
	return <Paragraph style="muted" alignment="center" text={content?.properties?.text} />;
};
